module.exports = __webpack_public_path__ + "images/stickers/laugh.f2dd1dd6f5945e8f1da2.png";